import {
    ERROR_CLEAR,
    SUCCESS_MESSAGE_CLEAR,
    USER_LOGIN_ERROR,
    USER_LOGIN_SUCCESS,
    USER_LOGOUT_FAIL,
    USER_LOGOUT_FAIL_CLEAR,
    USER_LOGOUT_SUCCESS,
    USER_LOGOUT_SUCCESS_CLEAR,
    USER_CREATE_SUCCESS,
    USER_CREATE_FAIL,
    USER_GET_SUCCESS,
    USER_GET_FAIL,
    USER_UPDATE_SUCCESS,
    USER_UPDATE_FAIL,
    USER_DELETE_SUCCESS,
    USER_DELETE_FAIL,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_FAIL,
    USER_OTP_REQUIRED,
    USER_RESEND_OTP_SUCCESS,
    USER_RESEND_OTP_FAIL,
    /* RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAIL */
} from "../types/userTypes";

import axios from "axios";

import { SERVER_URL } from '../../config/keys';

export const userAuth = () => {
    axios.interceptors.request.use(
        (config) => {
            // config.headers.authorization = `Bearer ${token}`;
            config.headers = {
                ...config.headers,
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            };

            config.withCredentials = true

            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
};

export const LoginUser = (data) => {
    userAuth();
    return async (dispatch) => {
        try {
            const response = await axios.post(`${SERVER_URL}/api-v1/user/login`, data);

            // If 2FA is enabled and OTP is required
            if (response.data.requiresOTP) {
                dispatch({
                    type: USER_OTP_REQUIRED,
                    payload: {
                        message: response.data.message,
                        userId: response.data.userId,
                        email: data.email // Store the email for resending OTP if needed
                    }
                });
                // Return the OTP required status to the component
                return { requiresOTP: true, userId: response.data.userId };
            }

            // Normal login success
            dispatch({
                type: USER_LOGIN_SUCCESS,
                payload: {
                    successMessage: response.data.message,
                    currentUser: response.data.currentUser
                }
            });

            return { requiresOTP: false };
        } catch (error) {
            let data = error?.response?.data?.message;
            dispatch({
                type: USER_LOGIN_ERROR,
                payload: {
                    error: data
                }
            });
            return { error: data };
        }
    }
};

/**
 * Resend OTP for login verification
 */
export const ResendLoginOTP = (email) => {
    userAuth();
    return async (dispatch) => {
        try {
            const response = await axios.post(`${SERVER_URL}/api-v1/otp/generate-public`, {
                email,
                purpose: 'login'
            });

            dispatch({
                type: USER_RESEND_OTP_SUCCESS,
                payload: {
                    successMessage: response.data.message
                }
            });

            return { success: true, message: response.data.message };
        } catch (error) {
            let data = error?.response?.data?.message || 'Failed to resend OTP';
            dispatch({
                type: USER_RESEND_OTP_FAIL,
                payload: {
                    error: data
                }
            });

            return { success: false, error: data };
        }
    }
};

/**
 * Verify OTP for login
 */
export const VerifyLoginOTP = (email, otp, password) => {
    userAuth();
    return async (dispatch) => {
        try {

            const loginResponse = await axios.post(`${SERVER_URL}/api-v1/user/login`, {
                email,
                password,
                otp
            });

            if (!loginResponse.data.status) {
                throw new Error(loginResponse.data.message || 'Login failed');
            }

            dispatch({
                type: USER_LOGIN_SUCCESS,
                payload: {
                    successMessage: loginResponse.data.message || 'Login successful',
                    currentUser: loginResponse.data.currentUser
                }
            });

            localStorage.setItem("auth", true);

            return { success: true };
        } catch (error) {
            console.error("OTP verification error:", error);

            let errorMessage = error?.response?.data?.message || error.message || 'Failed to verify OTP';

            dispatch({
                type: USER_LOGIN_ERROR,
                payload: {
                    error: errorMessage
                }
            });

            return { success: false, error: errorMessage };
        }
    }
};

export const ForgotMyPassword = (data) => {
    return async (dispatch) => {
        try {
            userAuth();
            const response = await axios.post(`${SERVER_URL}/api-v1/user/forgot-password`, data);
            dispatch({
                type: FORGOT_PASSWORD_SUCCESS,
                payload: {
                    successMessage: response.data.message
                },
            });
        } catch (error) {
            let data = error?.response?.data?.message;
            // console.log(data)
            dispatch({
                type: FORGOT_PASSWORD_FAIL,
                payload: {
                    errorMessage: data,
                },
            });
        }
    };
};

export const ResetMyPassword = (data) => {
    return async (dispatch) => {
        try {
            userAuth();
            const response = await axios.post(`${SERVER_URL}/api-v1/user/reset-password`, data);
            dispatch({
                type: USER_UPDATE_SUCCESS,
                payload: {
                    successMessage: response.data.message
                },
            });

        } catch (error) {
            let data = error?.response?.data?.message;
            // console.log(data)
            dispatch({
                type: USER_UPDATE_FAIL,
                payload: {
                    errorMessage: data,
                },
            });
        }
    };
};

export const GetCurrentUser = (data) => {
    userAuth();
    return async (dispatch) => {
        try {
            const response = await axios.post(`${SERVER_URL}/api-v1/user/get-current-user`, {});

            // User is authenticated, handle accordingly
            // console.log('User data:', response.data.currentUser);
            // You may want to update your Redux store or perform other actions here
            dispatch({
                type: USER_LOGIN_SUCCESS,
                payload: {
                    // successMessage: response.data.message,
                    successMessage: null,
                    currentUser: response.data.currentUser
                }
            })
        } catch (error) {
            let data = error?.response?.data?.message;
            if (data === "Your session has expired. Please re-login to continue.") {
                // User session expired, clear the Redux store
                localStorage.setItem("auth", false);
                dispatch({
                    type: USER_LOGOUT_SUCCESS,
                    payload: {
                        successMessage: data,
                    },
                });
                dispatch({
                    type: USER_LOGIN_ERROR,
                    payload: {
                        error: data
                    }
                })
            } else {
                dispatch({
                    type: USER_LOGIN_ERROR,
                    payload: {
                        error: data
                    }
                })
            }

        }
    }
}

export const GetUsers = (data) => {
    userAuth();
    return async (dispatch) => {
        try {
            const response = await axios.post(`${SERVER_URL}/api-v1/user/get-users`, {});
            // console.log(response)
            dispatch({
                type: USER_GET_SUCCESS,
                payload: {
                    successMessage: response.data.message,
                    users: response.data.users
                }
            })
        } catch (error) {
            let data = error?.response?.data?.message;
            if (data.includes("Your session has expired.")) {
                console.log("here");
                // User session expired, clear the Redux store
                localStorage.setItem("auth", false);
                window.location.href = "/";
                dispatch({
                    type: USER_LOGOUT_SUCCESS,
                    payload: {
                        successMessage: data,
                    },
                });
                dispatch({
                    type: USER_GET_FAIL,
                    payload: {
                        error: data
                    }
                })
            } else {
                dispatch({
                    type: USER_GET_FAIL,
                    payload: {
                        error: data
                    }
                })
            }
        }
    }
}

export const CreateUser = (data) => {
    // console.log(data)
    userAuth();
    return async (dispatch) => {
        try {
            let response = await axios.post(`${SERVER_URL}/api-v1/user/create`, data);
            dispatch({
                type: USER_CREATE_SUCCESS,
                payload: {
                    users: response.data.users,
                    successMessage: response.data.message,
                }
            })
        } catch (error) {
            // console.log(error)
            let data = error?.response?.data?.message
            dispatch({
                type: USER_CREATE_FAIL,
                payload: {
                    errorMessage: data
                }
            })
        }
    }
}

export const LogoutUser = () => {
    return async (dispatch) => {
        try {
            userAuth();
            let response = await axios.post(`${SERVER_URL}/api-v1/user/logout-user`, {});
            // console.log(response)
            dispatch({
                type: USER_LOGOUT_SUCCESS,
                payload: {
                    successMessage: response.data.message,
                },
            });
        } catch (error) {
            let data = error.response.data.message;
            dispatch({
                type: USER_LOGOUT_FAIL,
                payload: {
                    errorMessage: data,
                },
            });
        }
    }
}

export const UpdateUser = (data) => {
    // console.log(data)
    return async (dispatch) => {
        try {
            userAuth();
            const response = await axios.put(`${SERVER_URL}/api-v1/user/update-user`, data);
            // console.log(response)
            dispatch({
                type: USER_UPDATE_SUCCESS,
                payload: {
                    users: response.data.users,
                    successMessage: response.data.message,
                }
            })
        } catch (error) {
            let data = error.response.data.message;
            dispatch({
                type: USER_UPDATE_FAIL,
                payload: {
                    error: data,
                },
            });
        }
    }
}

export const DeleteUser = (data) => {
    // console.log(data)
    return async (dispatch) => {
        try {
            userAuth();
            const response = await axios.post(`${SERVER_URL}/api-v1/user/delete-user`, data);
            // console.log(response)
            dispatch({
                type: USER_DELETE_SUCCESS,
                payload: {
                    users: response.data.users,
                    successMessage: response.data.message,
                }
            })
        } catch (error) {
            let data = error.response.data.message;
            dispatch({
                type: USER_DELETE_FAIL,
                payload: {
                    error: data,
                },
            });
        }
    }
}